export default {
  tabs: {
    profile: 'Perfil',
    branding: 'Marca',
    domain: 'Domínio',
    earning: 'Ganhos',
    feature_flags: 'Funcionalidades (flags)',
    notification_channels: 'Canais de notificação',
    pricing: 'Preços',
    fees: 'Taxas',
    payments: 'Pagamentos',
    billing: 'Faturação',
  },
  earning: {
    internal_notice: 'Definições exclusivas do Foodamigos. Não visíveis para o parceiro.',
    read_only_notice: 'Só de leitura. Clique em Editar para alterar qualquer valor.',
    editing_notice: 'A editar — as alterações afetam os cálculos reais de pagamento.',
  },
  fees: {
    internal_notice:
      'Definições exclusivas da FoodAmigos. Não visíveis para o parceiro, e apenas super administradores podem abrir este separador. As alterações afetam o valor cobrado aos clientes e a receita da plataforma.',
    read_only_notice: 'Apenas leitura. Clique em Editar para alterar qualquer valor neste separador.',
    editing_notice:
      'A editar — Guardar grava a taxa de serviço e as taxas de processamento. As taxas aplicam-se a partir da próxima cobrança; as transações anteriores mantêm a margem registada.',
  },
  profile: {
    read_only_notice: 'Só de leitura. Clique em Editar para alterar qualquer valor.',
    editing_notice: 'A editar — o nome de exibição é visível para os consumidores.',
    form: {
      name: {
        label: 'Nome do parceiro',
        hint: 'O nome legal/entidade. Usado internamente e em documentos de faturação.',
      },
      display_name: {
        label: 'Nome de exibição ao consumidor',
        hint: 'O rótulo «Powered by ___» mostrado aos clientes. Por omissão, usa o nome do parceiro se deixado em branco.',
      },
      admin_email: {
        label: 'Email do administrador',
        hint: 'A conta de administrador convidada. Não pode ser alterada aqui — contacte a equipa técnica para mover a conta.',
      },
      invoicing_emails: {
        label: 'E-mails de faturas',
        hint: 'Os recibos das faturas emitidas a este parceiro são enviados para cada um destes endereços. Deixe em branco para usar o e-mail do administrador.',
        placeholder: 'Email do administrador',
      },
      status: {
        label: 'Estado',
        hint: 'Os parceiros convidados ficam ativos no primeiro início de sessão — ativar manualmente ignora esse passo. Suspender desativa todos os acessos da equipa do parceiro.',
      },
      region: {
        label: 'Região',
        hint: 'O país é fixo. Escolha um estado quando os restaurantes do parceiro seguem regras de imposto ao nível do estado — isto altera apenas os valores predefinidos do parceiro, não os restaurantes existentes.',
      },
      messenger_audience: {
        label: 'Chat de suporte',
        hint: 'Quem, dentro deste parceiro, tem acesso ao chat de suporte FoodAmigos. A equipa FoodAmigos tem-no sempre. Os parceiros de marca branca dão suporte aos seus próprios restaurantes, por isso só os seus administradores o têm.',
        options: {
          everyone: 'Todos, incluindo os restaurantes',
          partner_admins: 'Apenas administradores do parceiro',
          nobody: 'Ninguém',
        },
      },
      shop_domains: {
        label: 'Domínios da loja',
        hint: 'Domínios raiz onde as lojas de restaurante do parceiro são servidas. O domínio principal é usado para novas marcas. O parceiro liga e desassocia os seus próprios domínios de loja; o separador Domínio mostra os respetivos registos DNS.',
      },
    },
    region: {
      whole_country: 'País inteiro',
    },
    shop_domains: {
      primary: 'Principal',
      platform_default: 'Predefinição da plataforma',
      empty: 'Nenhum domínio de loja associado ainda',
    },
    statuses: {
      invited: 'Convidado',
      active: 'Ativo',
      suspended: 'Suspenso',
    },
    custody: {
      label: 'Processamento de pagamentos',
      not_configured: 'Ainda não configurado',
      provider: 'Gateway próprio do parceiro',
      platform: 'A FoodAmigos processa os pagamentos',
      bank_account: {
        set: 'Conta bancária: {{label}} ({{status}})',
        missing: 'Ainda não há conta bancária. O parceiro introduz-a em Faturação do parceiro.',
        statuses: {
          active: 'ativa',
          pending_verification: 'em verificação',
          action_needed: 'ação necessária',
          errored: 'falha no pagamento',
          missing: 'em falta',
        },
      },
      hint: 'Decidido pela configuração de pagamento no separador Pagamentos e bloqueado assim que uma via for guardada. No processamento pela FoodAmigos, a parte da receita do parceiro é paga mensalmente.',
      kyc: {
        label: 'Conta de pagamento',
        missing: 'Ainda não criada',
        incomplete: 'Verificação incompleta',
        complete: 'Pronta para pagamentos',
        currently_due: 'A Stripe ainda precisa de: {{fields}}',
        send_link: 'Enviar link de integração',
        link_copied:
          'Link de integração copiado para a área de transferência — envie-o ao parceiro. É de utilização única e expira.',
        link_ready: 'Link de integração — envie-o ao parceiro (utilização única, expira)',
        link_failed: 'Não foi possível criar o link de integração.',
      },
    },
    suspend_confirm: {
      title: 'Suspender este parceiro?',
      description:
        'Todos os membros da equipa do parceiro serão desativados e as suas sessões revogadas. Os seus restaurantes permanecem ativos.',
    },
  },
  branding: {
    read_only_notice: 'Só de leitura. Clique em Editar para alterar qualquer valor.',
    editing_notice: 'A editar — as alterações são visíveis nas superfícies white-label do parceiro.',
    upload: 'Carregar logótipo',
    logo: {
      label: 'Logótipo',
      hint: 'Mostrado nas superfícies white-label do parceiro.',
    },
    circle_logo: {
      label: 'Favicon / logótipo circular',
      hint: 'Logótipo quadrado usado como favicon e avatar. Opcional — pode ser removido.',
    },
    splash_image: {
      label: 'Imagem de início de sessão',
      hint: 'Preenche a metade esquerda da página de início de sessão white-label do parceiro de ponta a ponta (corte cover). Recomendado: composição vertical, pelo menos 1200×1200px. Opcional — pode ser removida.',
    },
    footer_note: 'Mais opções de marca (cores secundárias) disponíveis brevemente.',
  },
  revenue_split: {
    title: 'Divisão de receitas',
    description:
      'Defina a parte do parceiro em cada taxa que o Foodamigos cobra nas encomendas dos seus restaurantes. Por omissão é 0% — o Foodamigos fica com a totalidade até ser concedida uma parte. Pago em cada ciclo de faturação.',
    manage_on_fees: 'Gerir no separador Taxas',
    split: 'Parceiro {{partner}}% · Foodamigos {{platform}}%',
    rows: {
      processing: 'Taxas de processamento',
      gift_card: 'Taxa de cartão oferta',
      delivery: 'Taxas de entrega',
      service_fee: 'Taxa de serviço',
    },
    notes: {
      service_fee: 'O valor cobrado aos clientes é definido em Controlos de taxa de serviço, no separador Taxas.',
    },
  },
  service_fee_controls: {
    title: 'Controlos da taxa de serviço',
    description: 'O que o parceiro cobra aos seus clientes como taxa de serviço sobre a encomenda.',
    zero_percentage_warning:
      'Uma percentagem de 0% não desativa a taxa de serviço: as taxas calculadas abaixo do valor mínimo são arredondadas para esse valor, pelo que todas as encomendas são cobradas pelo menos o mínimo.',
  },
  hard_limits: {
    title: 'Limites máximos',
    description:
      'Tetos do Foodamigos aplicados ao guardar e no checkout. Nenhuma taxa de serviço deste parceiro — incluindo substituições por restaurante — pode exceder estes valores.',
    max_percentage: {
      label: 'Taxa de serviço máxima %',
      help: 'A taxa de serviço do parceiro não pode ser definida acima deste valor. Limite da plataforma: 5%.',
    },
    min_amount: {
      label: 'Valor mínimo da taxa de serviço',
      help: 'Os mínimos por restaurante não podem ser definidos abaixo deste valor.',
    },
    max_amount: {
      label: 'Valor máximo da taxa de serviço',
      help: 'Teto absoluto da taxa de serviço fixa, independentemente da percentagem.',
    },
  },
  form: {
    is_service_fee_change_allowed: {
      label: 'Permitir alterar a taxa de serviço por restaurante',
      description: 'Permite que os restaurantes individuais do parceiro utilizem uma taxa de serviço diferente.',
    },
    service_fee_platform_share: {
      label: 'Parte do Foodamigos na taxa de serviço',
    },
    recommended: 'Recomendado: {{value}}',
    service_fee_percentage: {
      label: 'Percentagem de taxa de serviço predefinida',
      help: 'Aplicada a cada restaurante do parceiro, salvo substituição.',
    },
    min_service_fee_amount: {
      label: 'Valor mínimo de taxa predefinido',
      help: 'Mínimo predefinido por encomenda — as taxas calculadas abaixo são arredondadas para cima. Os restaurantes podem definir o seu próprio dentro dos limites do Foodamigos.',
    },
    max_service_fee_amount: {
      label: 'Valor máximo de taxa predefinido',
      help: 'Teto predefinido por encomenda — os restaurantes podem definir o seu próprio dentro dos limites do Foodamigos.',
    },
    primary_color: {
      label: 'Cor principal da marca',
    },
    dashboard_subdomain: {
      label: 'Slug de login do parceiro',
      hint: 'Slug em minúsculas — identifica a marca do parceiro na ligação de login da sua equipa (?partner=…).',
      placeholder: 'nome-do-parceiro',
    },
    login_url: {
      label: 'Ligação de login da equipa',
      hint: 'A ligação que a equipa do parceiro utiliza para aceder à sua página de login personalizada.',
    },
    file: {
      label: 'Imagem',
    },
  },
  buttons: {
    edit: 'Editar',
    cancel: 'Cancelar',
    save: 'Guardar',
  },
  toasts: {
    load_error: 'Não foi possível carregar as definições.',
    failed_to_save_changes: 'Falha ao guardar as alterações',
    changes_got_saved: 'Alterações guardadas',
    logo_uploaded: 'Logótipo carregado',
    logo_upload_failed: 'Falha ao carregar o logótipo',
    logo_removed: 'Logótipo removido',
    logo_remove_failed: 'Falha ao remover o logótipo',
    file_too_large: 'Ficheiro demasiado grande. O tamanho máximo é {{max}} MB.',
    image_too_narrow: 'A imagem de início de sessão deve ter pelo menos {{min}}px de largura.',
  },
  notification_channels: {
    master_locked:
      'O parceiro principal envia para todos os restaurantes da plataforma, por isso os seus canais não podem ser alterados aqui.',
    unavailable: 'Os canais de notificação ainda não estão disponíveis neste backend.',
    notice:
      'Definição interna. Um parceiro sem conta Twilio própria deve ficar apenas com email: caso contrário, todos os SMS, mensagens WhatsApp e chamadas de voz sairiam pela conta Twilio da FoodAmigos.',
    forbidden: 'Só os super admins podem alterar os canais de notificação.',
    columns: {
      channel: 'Canal',
      status: 'Ativo',
    },
    channels: {
      email: {
        name: 'Email',
        description: 'Sempre ativo, para que o parceiro e os seus restaurantes possam sempre ser contactados.',
      },
      sms: {
        name: 'SMS',
        description: 'Atualizações de encomendas e códigos de acesso para clientes por SMS.',
      },
      whatsapp: {
        name: 'WhatsApp',
        description: 'Alertas para os proprietários dos restaurantes e códigos de acesso para clientes via WhatsApp.',
      },
      voice_call: {
        name: 'Chamadas de voz',
        description: 'Chamadas de lembrete para encomendas pendentes e atendimento telefónico.',
      },
      push: {
        name: 'Notificações push',
        description:
          'Notificações push para clientes e para a app de painel do proprietário. Os alertas do tablet da equipa não são afetados.',
      },
    },
    toasts: {
      load_error: 'Não foi possível carregar os canais de notificação.',
      error: 'Não foi possível guardar os canais de notificação.',
      saved: 'Canais de notificação guardados.',
    },
  },
  feature_flags: {
    internal_notice:
      'Definições exclusivas da Foodamigos. Não visíveis para o parceiro. As alterações têm efeito imediato.',
    read_only:
      'Só de leitura — alterar a faturação do restaurante requer uma implementação coordenada, não um simples botão. Fale com a engenharia.',
    forbidden: 'Apenas super administradores podem gerir as funcionalidades dos parceiros.',
    columns: {
      feature: 'Funcionalidade',
      status: 'Estado',
    },
    flags: {
      external_printer: {
        name: 'Impressora de recibos externa',
        description:
          'O padrão para os restaurantes que este parceiro integra a partir de agora: cada novo restaurante começa com a possibilidade de ligar uma impressora de recibos de rede à app do terminal de pedidos. Os restaurantes existentes mantêm o que estiver definido no seu separador Feature Flags e cada restaurante pode continuar a ser alterado individualmente aí.',
      },
      plg_onboarding: {
        name: 'Onboarding self-serve (PLG)',
        description:
          'Onboarding self-serve de parceiros: dá a este parceiro a página guiada de Novo restaurante e o assistente de onboarding em vez do modal clássico Adicionar empresa e do assistente Começar, oculta funcionalidades exclusivas da FoodAmigos e ainda não aplicáveis para o parceiro e os seus restaurantes, e bloqueia o primeiro go-live até se acordar uma data de lançamento. Ativo para todos os novos parceiros.',
      },
      issue_end_customer_receipts: {
        name: 'Faturas para o cliente final',
        description:
          'Permite que os clientes solicitem uma fatura no checkout e a recebam por email. Desativado para novos parceiros; as regras internacionais de formato de fatura tornam o suporte dispendioso.',
      },
      merchant_billing: {
        name: 'Faturação de restaurantes',
        description:
          'Fatura os restaurantes do parceiro através da plataforma. Desativado significa que liquidam fora dela.',
      },
      cuisine_backfill: {
        name: 'Preenchimento automático de cozinhas',
        description:
          'Permite que o preenchimento automático do tipo de cozinha seja executado para os restaurantes deste parceiro.',
      },
      image_backfill: {
        name: 'Preenchimento automático de imagens',
        description:
          'Permite que o preenchimento automático de imagens de menu seja executado para os restaurantes deste parceiro.',
      },
      auto_image_generation: {
        name: 'Geração automática de imagens',
        description: 'Gera imagens de menu a pedido para os restaurantes deste parceiro.',
      },
      provider_billing: {
        name: 'Faturação do parceiro pela Foodamigos',
        description:
          'Inclui este parceiro no ciclo de faturação da Foodamigos. Desativado significa que o parceiro é faturado fora da plataforma. Também ativa o PayPal (direto) para os restaurantes deste parceiro, com a taxa de serviço cobrada sobre o mesmo.',
      },
      partner_custom_dashboard_domain: {
        name: 'Domínio próprio do painel',
        description:
          'Permite que este parceiro utilize um domínio próprio para o painel, para que a equipa e os restaurantes iniciem sessão sob o endereço do parceiro. Ativar ou desativar altera todos os links do painel enviados pela plataforma para este parceiro.',
      },
      partner_custom_shop_domain: {
        name: 'Domínio de loja próprio',
        description:
          'Permite a este parceiro ligar um domínio próprio para as lojas online dos seus restaurantes, no qual cada restaurante recebe o seu próprio endereço. Ative um parceiro de cada vez: altera o endereço que os clientes utilizam.',
      },
      partner_legal_documents: {
        name: 'Documentos legais do parceiro',
        description:
          'Gera o aviso legal, a política de privacidade e os termos das lojas de restaurantes deste parceiro a partir dos dados legais de cada restaurante. Desativado, ou enquanto os dados de um restaurante estiverem incompletos, as lojas mostram os documentos padrão da plataforma.',
      },
    },
    toasts: {
      load_error: 'Falha ao carregar as funcionalidades',
      error: 'Falha ao alterar a funcionalidade',
      enabled: 'Funcionalidade ativada',
      disabled: 'Funcionalidade desativada',
    },
  },
};
